import React, { memo, useMemo } from 'react';
import { MenuItem } from 'primereact/menuitem';
import { PanelMenu } from 'primereact/panelmenu';
import './OrganisationMenu.css';
import { useNavigate } from 'react-router-dom';

const Organisationmenu = () => {
  const navigate = useNavigate();

  const items = useMemo<MenuItem[]>(
    () => {
      const createMenuItem = (
        label: string,
        icon: string,
        path?: string,
        children?: MenuItem[]
      ): MenuItem => ({
        label,
        icon,
        command: path ? () => navigate(path) : undefined,
        items: children,
        template: (item, options) => (
          <a {...options} data-testid={`menu-${label.toLowerCase().replace(/\s+/g, '-')}`}>
            <span className={item.icon}></span>
            <span className="ml-2">{item.label}</span>
          </a>
        )
      });

      return [
        createMenuItem('Dashboard', 'pi pi-fw pi-palette', '/odashboard'),
        createMenuItem('Needs', 'pi pi-heart-fill', '/orgneeds'),
        createMenuItem('Donations', 'pi pi-fw pi-dollar', '/receiveddonations'),
        createMenuItem('Documents', 'pi pi-file', '/odocument'),
        createMenuItem('Feedback', 'pi pi-envelope', '/ofeedback'),
        createMenuItem('Applications', 'pi pi-fw pi-building', '/oorgapplications'),
        createMenuItem('Reports', 'nav-icon fas fa-copy', undefined, [
          createMenuItem('Donor Reports', 'pi pi-user', '/donortranscript'),
          createMenuItem('FundManager Reports', 'pi pi-sitemap', '/fundmanagertranscript')
        ])
      ];
    },
    [navigate]
  );

  return (
    <aside className="main-sidebar">
      <div className="menu">
        <div className="font-bold border-round flex align-items-center justify-content-center">
          <PanelMenu model={items} />
        </div>
      </div>
    </aside>
  );
};

export default memo(Organisationmenu);
